export const GEOFENCE_SETTINGS = 'geofenceSettings';
